/**
 * Form styles using Tailwind tenant classes
 * Replaces the old formStyles from tenantStyles.ts
 */

export const formStyles = {
  input: 'h-14 text-sm md:text-base bg-white text-dark-blue border-light-grey',
  input_focus:
    'focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-tenant-primary-action-color',
  input_focus_alt: 'focus:ring-0 focus:ring-offset-0 focus:border-tenant-primary-action-color',
  label: 'flex items-center mb-2 text-sm md:text-base cursor-pointer',
  info_icon: 'h-4 w-4 text-tenant-primary-action-color ml-2',
  select: 'rounded-lg bg-white text-dark-blue border-light-grey',
  select_option: 'rounded text-base text-dark-blue hover:bg-light-grey focus:bg-light-grey',
}

/**
 * Gap size mappings for form layouts
 */
export const GAP_CLASSES = {
  sm: 'gap-4',
  md: 'gap-8',
  lg: 'gap-16',
  xl: 'gap-32',
} as const
